import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, RadioGroup, InputText } from '@teo/components';
import { round2 } from '@/util';

const backgroundColor = '#EAEAED';
const blurColor = '#C2CDFE';
const focusColor = '#7089FD';

const ResultsLP = ({ trainingDetail, handleChangeTraining }) => {
  const { t } = useTranslation();

  const [scoreAfterFinishing, setScoreAfterFinishing] = useState(
    trainingDetail?.inputScore
  );
  const [inputScore, setInputScore] = useState(trainingDetail?.inputScoreType);
  const [uploadCertificate, setUploadCertificate] = useState(
    trainingDetail?.uploadCertificate
  );

  const [minScore, setMinScore] = useState(
    trainingDetail?.minScore ? trainingDetail?.minScore : 0
  );
  const percentageMinScore = round2(minScore ? minScore * 100 : 0.5 * 100);

  const [trackColor, setTrackColor] = useState(blurColor);

  const onChangeRadioBox = (value) => {
    setInputScore(value);
    handleChangeTraining({ inputScoreType: value });
  };

  return (
    <div className=" border-t px-5 pt-5">
      <h4 className="mb-1 text-base">
        {t('pages.learning_path.result_label')}
      </h4>
      <div className="mt-2 flex flex-col rounded-lg border border-grey-02 py-4">
        <div className="px-4">
          <div className="flex flex-row items-center gap-4 ">
            <Switch
              checked={scoreAfterFinishing}
              onChange={(isCheck) => {
                setScoreAfterFinishing(isCheck);
                handleChangeTraining({
                  inputScore: isCheck,
                  minScore: isCheck ? 0.5 : 1,
                });
                setMinScore(isCheck ? 0.5 : 1);
              }}
            />
            <div className="flex flex-col">
              <h4 className="font-normal">
                {t('pages.learning_path.settings.input_score')}
              </h4>
            </div>
          </div>
        </div>

        <div className="mt-4 flex flex-row items-center gap-4 border-t border-grey-02 px-4 pt-4 ">
          <div>
            <Switch
              checked={uploadCertificate}
              onChange={(isCheck) => {
                setUploadCertificate(isCheck);
                handleChangeTraining({ uploadCertificate: isCheck });
              }}
            />
          </div>
          <div>
            <p className="text-sm">
              {t('pages.learning_path.settings.upload_certificate')}
            </p>
          </div>
        </div>
        {(scoreAfterFinishing || uploadCertificate) && (
          <div className="mt-4 border-t border-grey-02 px-4">
            {/* <div className="z-1 relative top-px mt-4 w-full bg-[#EAEAED]"></div> */}
            <RadioGroup onChange={onChangeRadioBox} value={inputScore}>
              <RadioGroup.Option value="studentOrEvaluator">
                {t('pages.learning_path.settings.by_student_evaluator')}
              </RadioGroup.Option>
              <RadioGroup.Option value="evaluator">
                {t('pages.learning_path.settings.by_evaluator')}
              </RadioGroup.Option>
              <RadioGroup.Option value="student">
                {t('pages.learning_path.settings.by_student')}
              </RadioGroup.Option>
            </RadioGroup>
          </div>
        )}
        {scoreAfterFinishing && (
          <div className="mt-5 flex flex-row items-center gap-4 border-t border-grey-02 px-4 pt-6">
            <div className="flex w-full flex-col gap-4">
              <div className="flex w-full">
                <input
                  className="slider w-full flex-shrink"
                  max={100}
                  min={0}
                  onChange={(e) => {
                    setMinScore(parseFloat(e?.currentTarget.value) / 100);
                    handleChangeTraining({
                      minScore: parseFloat(e?.currentTarget.value) / 100,
                    });
                  }}
                  onMouseDown={() => setTrackColor(focusColor)}
                  onMouseUp={() => setTrackColor(blurColor)}
                  onTouchEnd={() => setTrackColor(blurColor)}
                  onTouchStart={() => setTrackColor(focusColor)}
                  step={5}
                  style={{
                    background: `linear-gradient(to right, ${trackColor} 0%, ${trackColor} ${percentageMinScore}%, ${backgroundColor} ${percentageMinScore}%, ${backgroundColor})`,
                  }}
                  value={percentageMinScore}
                  type="range"
                />
              </div>
              <div className="flex flex-row items-center gap-3">
                <p className="min-w-max text-sm">
                  {t('pages.course_content_flow.step_3.minimum_score')}
                </p>
                <InputText
                  type="number"
                  value={percentageMinScore}
                  onChange={(e) =>
                    setMinScore(parseFloat(e?.currentTarget.value) / 100)
                  }
                  suffix="%"
                  className="w-[90px]"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default ResultsLP;
